import { EVENTS, subscribe } from 'ia-util-pubsub';

class IaProductPrice extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.priceEl = this.querySelector('[data-price]');
    this.setupEventListeners();
    this.updatePrice();
  }

  setupEventListeners() {
    subscribe(EVENTS.planChange, this.updatePrice.bind(this));
    subscribe(EVENTS.cadenceChange, this.updatePrice.bind(this));
    subscribe(EVENTS.variantChange, this.updatePrice.bind(this));
  }

  updateVariantPrice(data) {
    const detail = data?.detail;
    if (detail && detail.productId === this.productId && detail.sectionId === this.sectionId) {
      const price = detail.html.querySelector("[data-price]")?.dataset.price;
      if (price) {
        this.priceEl.textContent = price;
      }
    }
  }


  updatePrice(data) {
    this.subscriptionWidget = this.closest('section')?.querySelector('ia-subscription-widget');
    if (this.subscriptionWidget) {
      this.updateSubscriptionPrice();
    }
    else {
      this.updateVariantPrice(data);
    }
  }



  updateSubscriptionPrice() {
    if (this.type === 'cart' && this.subscriptionWidget && this.subscriptionWidget.initialized) {
      let newPrice = '';
      if (this.subscriptionWidget?.cadence === 'subscription' && this.subscriptionWidget.planPrice) {
        newPrice = this.subscriptionWidget.planPrice;
      } else {
        newPrice = this.subscriptionWidget.variantPrice;
      }
      if (newPrice) {
        this.priceEl.textContent = newPrice;
      }
    }
  }

  get type() {
    return this.getAttribute('type');
  }
  get sectionId() {
    return this.getAttribute('section-id');
  }
  get productId() {
    return this.getAttribute('product-id');
  }
}

if (!customElements.get('ia-product-price')) {
  customElements.define('ia-product-price', IaProductPrice);
}
